import { render, staticRenderFns } from "./KCheckbox.vue?vue&type=template&id=6d997491&lang=pug"
import script from "./KCheckbox.vue?vue&type=script&lang=js"
export * from "./KCheckbox.vue?vue&type=script&lang=js"
import style0 from "./KCheckbox.vue?vue&type=style&index=0&id=6d997491&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports